import * as API from "middleware/api";

export const fetchCampaign = (section) =>
    API.executeWithAccessToken("/campaigns.readRandomCampaignBySection", { section });

export const fetchAnonymousCampaign = (section) =>
    API.executeAnonymous("/campaigns.readRandomCampaignBySectionAnonymous", { section });

export const fetchAnonymousActiveCampaigns = (section) =>
    API.executeAnonymous("/campaigns.readActiveCampaignsBySectionAnonymous", { section });

export const fetchActiveCampaigns = (section) =>
    API.executeWithAccessToken("/campaigns.readActiveCampaignsBySection", { section });

export const fetchCampaignImage = (params) => API.executeAnonymous("/campaigns.readCampaignImage", params);

export const dismissPermanentCampaign = (idCampaign) =>
    API.executeWithAccessToken("/campaigns.userDismissCampaign", idCampaign);
